import { Injectable } from '@angular/core';
import { BaseControl, Textbox, Legend, Container, TextArea } from '@app/shared';
import { Validators } from '@angular/forms';

@Injectable()
export class SmtpManagementFormService {

  constructor() { }

  /**
   * Construye y retorna el forimulario de modificacion del smts
   *
   * @param {*} [smtp]
   * @returns {BaseControl<any>[]}
   * @memberof SmtpManagementFormService
   */
  getFormSmtp(smtp?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'host',
        value: smtp ? smtp.host ? smtp.host : null : null,
        label: 'Host',
        placeholder: 'Host',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'port',
        value: smtp ? smtp.port ? smtp.port : null : null,
        label: 'Puerto',
        placeholder: 'Puerto',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'username',
        value: smtp ? smtp.username ? smtp.username : null : null,
        label: 'Usuario',
        placeholder: 'Usuario',
        order: 3,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'password',
        type: 'password',
        value: smtp ? smtp.password ? smtp.password : null : null,
        label: 'Contraseña',
        placeholder: 'Contraseña',
        order: 4,
        validations: {
          validators: [Validators.required]
        }
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-system/smtp-management/shared/smtp-management-form.service.ts